// PublicConfig.apiBaseUrl, or "" when the configuration is invalid: the configuration error screen
// shows then and no call is made (FR-036).
import { ConfigError, readPublicConfig } from "@/config";

export function configuredBaseUrl(): string {
  try {
    return readPublicConfig().apiBaseUrl;
  } catch (error) {
    if (error instanceof ConfigError) return "";
    throw error;
  }
}
